(() => {
  const createBoxId = () => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return `curated-${window.crypto.randomUUID()}`;
    }

    return `curated-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  };

  const initialise = (root) => {
    if (root.dataset.sgCuratedInitialised === 'true') return;
    root.dataset.sgCuratedInitialised = 'true';

    const form = root.closest('form[action*="/cart/add"]');
    const start = root.querySelector('[data-sg-curated-start]');
    const back = root.querySelector('[data-sg-curated-back]');
    const details = root.querySelector('[data-sg-curated-details]');
    const recipient = root.querySelector('[data-sg-curated-recipient]');
    const giftNote = root.querySelector('[name="properties[Gift note]"]');
    const publicId = root.querySelector('[data-sg-curated-box-id]');
    const privateId = root.querySelector('[data-sg-curated-private-id]');
    const privateTitle = root.querySelector('[name="properties[_curated_gift_box_title]"]');

    if (!form || !start || !back || !details || !recipient || !publicId || !privateId) return;

    // Keep one stable private association on the line item. The identifier is
    // required for reliable grouping, but it is not fulfilment copy and should
    // not appear on customer-facing cart or checkout surfaces.
    publicId.name = 'properties[_Box]';
    privateId.disabled = true;
    if (privateTitle) privateTitle.disabled = true;

    const ensureBoxId = () => {
      if (!publicId.value) publicId.value = createBoxId();
    };

    start.addEventListener('click', () => {
      ensureBoxId();
      start.hidden = true;
      details.hidden = false;
      recipient.focus();
      details.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    back.addEventListener('click', () => {
      details.hidden = true;
      start.hidden = false;
      start.focus();
    });

    form.addEventListener('submit', (event) => {
      if (details.hidden) {
        event.preventDefault();
        start.click();
        return;
      }

      ensureBoxId();
    }, true);

    form.addEventListener('ajaxProduct:added', () => {
      publicId.value = '';
      privateId.value = '';
      recipient.value = '';
      if (giftNote) giftNote.value = '';
      details.hidden = true;
      start.hidden = false;
    });
  };

  const initialiseAll = () => {
    document.querySelectorAll('[data-sg-curated-gift]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }
})();
